// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePaperclip as RawLucidePaperclip } from "lucide-react";
export const LucidePaperclip = /* @__PURE__ */ createIcon(RawLucidePaperclip, "LucidePaperclip", 2);
